import { IImage } from '../../../types/newbuildingHeader';
import { IMedia, EMediaType } from '../../Carousel';

export const prepareSlides = (images: IImage[]): IMedia[] => {
  return images.map(item => ({
    type: EMediaType.Photo,
    src: item.fullUrl,
  }));
};
